<template>
  <!-- 吸顶时给这一行留出文档流占位（.hold-height）：Row 变 position: fixed 后父级会塌掉
       32px，下方内容整体上跳一下，看着就是吸顶瞬间「闪」 -->
  <div class="header-box" :class="{ 'hold-height': fixHeader }">
    <Row :class="[fixHeader ? 'fixed' : '', 'header-menu']">
      <div class="content b pb">
        <i-col span="12" class="b lr ac">
          <img :src="this.config.logo" alt class="icon" />
          <p v-if="this.config">{{ this.config.top_slogan }}</p>
          <div class="userBox">
            <NavBtn
              v-if="!hasLogin"
              url="/login?redirect_url=/"
              text="登录"
              type="default"
              style="border: none;"
              class="logBtn"
            />
            <template v-for="menu in rightMenus">
              <Dropdown
                @on-click="tapUserMenu"
                v-if="menu.type === 'dropdown'"
                :key="menu.text"
              >
                <a href="javascript:void(0)">
                  {{ menu.text }}
                  <Icon type="ios-arrow-down"></Icon>
                </a>
                <DropdownMenu slot="list">
                  <DropdownItem
                    v-for="(item, index) in routerData"
                    :key="index"
                    :divided="true"
                    :name="item.path"
                    >{{ item.name }}</DropdownItem
                  >
                  <DropdownItem v-if="logoutShow" :divided="true" name="logout"
                    >退出登录</DropdownItem
                  >
                </DropdownMenu>
              </Dropdown>
            </template>
          </div>
        </i-col>
        <i-col span="12" class="b rl ac" v-if="showRightMenu">
          <div class="headRight b">
            <div
              v-for="(menu, index) in rightMenus"
              :key="index"
              class="itemBox"
            >
              <div
                v-if="menu.type !== 'dropdown'"
                :key="menu.text"
                type="text"
                style="font-size:12px;margin-left: 5px;"
                @click="tapMenu(menu)"
                class="item"
                :class="menu.text == '购物车' && ishideCart ? 'hide' : ''"
              >
                {{ menu.text }}
                <!-- 购物车商品数量 -->
                <span class="goodsNum">{{ menu.goodsNum }}</span>
              </div>
            </div>
            <div class="itemBox" @click="toService()" v-if="showService">
              <div class="item">在线客服</div>
            </div>
            <Dropdown
              style="margin-left: 15px"
              class="service"
              trigger="hover"
              v-if="!alone && wxcodeShow"
            >
              <p class="dropdown-p b cc">
                微信版
                <Icon type="ios-arrow-down"></Icon>
              </p>
              <DropdownMenu slot="list">
                <DropdownItem>
                  <img
                    class="mobile-qrcode"
                    v-if="this.configData.wechat_code"
                    :src="this.configData.wechat_code"
                    alt="mobile"
                  />
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </i-col>
      </div>
    </Row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import throttle from 'lodash/throttle';
import { jump } from '../../common';
import localStorage from '../../utils/storage/localStorage';
import sessionStorage from '../../utils/storage/sessionStorage';
import { opCartCount } from '@/service/opApis';
import { elementClick } from '@/utils/track/baidu_statistics';
import { hideCart } from '@/config';
export default {
  name: 'headerMenu',
  data() {
    return {
      fixHeader: false,
      goodsCount: 0,
      showRightMenu: true,
      leftMenus: [
        {
          text: '登录',
          action: 'jump',
          scheme: '/login?redirect_url=/'
        }
      ],
      routerData: [
        {
          name: '我的福利',
          path: '/userCenter/cards'
        },
        {
          name: '我的订单',
          path: '/userCenter/order'
        },
        {
          name: '收货地址',
          path: '/userCenter/address'
        }
      ],
      rightMenus: [
        {
          text: '商城首页',
          action: 'jump',
          scheme: '/mall?channel_id=10',
          blank: false
        },
        {
          text: '个人中心',
          action: 'jump',
          scheme: '/userCenter?from=home',
          blank: false
        },
        {
          text: '购物车',
          action: 'jump',
          scheme: '/cart_v2?from=home',
          goodsNum: sessionStorage.get('goodsCount')
            ? sessionStorage.get('goodsCount')
            : '',
          blank: false
        },
        {
          text: '官网',
          action: 'jump',
          scheme: 'http://www.pandayoufu.com?from=pc-nav',
          blank: true
        }
      ],
      hasLogin: false,
      hideCartList: hideCart,
      ishideCart: false,
      alone: false,
      logoutShow: true,
      wxcodeShow: true, //是否显示微信版二维码
      showService: true
    };
  },
  props: ['configData'],
  components: {
    // serviceCard
  },
  mounted() {
    this.init();
    this.checkLogin();
    this.listenScroll();

    // 样式配置
    this.setAlone();
    this.activeConfig();
  },
  activated() {
    this.setAlone();
    this.activeConfig();
  },
  computed: {
    ...mapState('common', ['config', 'alone_custom']),
    goodsNum() {
      return this.$store.state.cart.goodsCount;
    }
  },
  methods: {
    init() {
      this.ishideCart = false;
      // 部分页面隐藏购物车入口
      this.hideCartList.map(item => {
        if (window.location.pathname.includes(item)) {
          this.ishideCart = true;
        }
      });
      //
      let custom_id =
        this.$route.query.custom_id || sessionStorage.get('custom_id');
      if (+custom_id == 362) {
        this.rightMenus = this.rightMenus.map(item => {
          if (item.text == '商城首页') {
            item.text = '首页';
            item.scheme = '/home?custom_id=362';
          }
          return item;
        });
      }
      if (+custom_id == 806) {
        this.rightMenus = this.rightMenus.map(item => {
          if (item.text == '商城首页') {
            item.text = '首页';
            item.scheme =
              '/partition?mode=exchange&channel_id=2137&custom_id=806';
          }
          return item;
        });
      }
    },
    doAction() {
      return {
        jump: (info = {}) => {
          const { scheme, blank } = info;
          if (scheme) {
            if (scheme == '/mall?channel_id=10') {
              sessionStorage.set('channel_id', 10);
            }
            jump(scheme, blank);
          }
        }
      };
    },
    tapMenu(menu = {}) {
      const { action } = menu;
      this.doAction()[action](menu);
    },
    tapUserMenu(name) {
      if (name === 'logout') {
        localStorage.remove('session_info');
        sessionStorage.remove('goodsCount');
        window.location.href =
          window.location.origin +
          '/login?redirect_url=' +
          encodeURIComponent(window.location.href);
      } else {
        jump(`${name}`);
      }
      elementClick('导航栏', name);
    },
    whenBroswerScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 吸顶临界点 700，给 10px 回滞：停在临界高度附近时不会反复吸顶/取消（看着就是闪屏）
      this.fixHeader = this.fixHeader ? scrollTop >= 690 : scrollTop >= 700;
    },
    listenScroll() {
      // throttle 每次调用都返回新函数，注册与移除必须用同一个引用，否则监听永不释放
      // 1000ms 太糙：头部（以及跟着它吸顶的 tab 行）会滞后近一秒，看着就是「不同步」
      this.scrollHandler = throttle(this.whenBroswerScroll, 100);
      window.addEventListener('scroll', this.scrollHandler, true);
      this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('scroll', this.scrollHandler);
      });
    },
    toService() {
      // 在线客服
      window.open(this.config.customer_service_url);
    },
    activeConfig() {
      // 官网定制
      let official_url = this.config.official_url;
      if (official_url) {
        let isExit = this.rightMenus.some(item => {
          return item.text == '官网';
        });
        if (isExit) {
          this.rightMenus = this.rightMenus.map(item => {
            if (item.text == '官网') {
              item.scheme = official_url;
            }
            return item;
          });
        } else {
          this.rightMenus.push({
            text: '官网',
            action: 'jump',
            scheme: official_url,
            blank: true
          });
        }
      } else {
        this.rightMenus = this.rightMenus.filter(item => {
          return item.text != '官网';
        });
      }
      if (window.location.pathname == '/infoGathering') {
        this.showRightMenu = false;
        this.routerData = [];
      }

      // 最后配置是否隐藏某些模块
      this.configHide();
    },
    setAlone() {
      if (this.alone_custom) {
        this.alone = true;
        this.rightMenus = [
          {
            text: '首页',
            action: 'jump',
            scheme: '/customization',
            blank: false
          },
          {
            text: '个人中心',
            action: 'jump',
            scheme: '/userCenter?from=home',
            blank: false
          },
          {
            text: '官网',
            action: 'jump',
            scheme: 'http://www.pandayoufu.com?from=pc-nav',
            blank: true
          }
        ];
      }
    },
    checkLogin() {
      setTimeout(() => {
        const sessionInfo = localStorage.get('session_info');
        if (sessionInfo) {
          this.rightMenus = [
            {
              text: sessionInfo.nickname,
              type: 'dropdown'
            },
            ...this.rightMenus
          ];
          // 如果登录了,获取购物车中商品数量
          opCartCount({}).then(res => {
            this.rightMenus = this.rightMenus.map(item => {
              if (item.text == '购物车') {
                item.goodsNum = res.goods_number;
              }
              return item;
            });
            sessionStorage.set('goodsCount', res.goods_number);
          });
        }
        this.hasLogin = !!sessionInfo;
      }, 500);
    },
    configHide() {
      // 通过配置隐藏某些模块
      if (!this.config || !this.config.pc_hide_model) return false;
      this.config.pc_hide_model.some(item => {
        if (item == 'logOut') {
          this.logoutShow = false;
        }
        if (item == 'wxCode') {
          this.wxcodeShow = false;
        }
        if (item == 'official_website') {
          this.rightMenus = this.rightMenus.filter(item => {
            return item.text !== '官网';
          });
        }
        if (item == 'cart') {
          this.ishideCart = true;
        }
        if (item == 'online_service') {
          this.showService = false;
        }
      });
    }
  },
  //监听执行
  watch: {
    goodsNum(val) {
      this.rightMenus = this.rightMenus.map(item => {
        if (item.text == '购物车') {
          item.goodsNum = val;
        }
        return item;
      });
    },
    $route() {
      this.init();
    },
    config() {
      this.activeConfig();
    },
    alone_custom() {
      this.setAlone();
    }
  }
};
</script>

<style lang="scss" scoped>
.hide {
  display: none;
}
.header-box {
  // 吸顶时把这一行原本在文档流里占的 32px（见 .header-menu 的 height: 32px）留下来：
  // Row 变 position: fixed 后父级会塌成 0，下方内容整体上跳 32px，靠位置判定的吸顶元素
  // （如 /live_service 的分类 tab）也会跟着抖 —— 表现就是吸顶瞬间闪一下
  &.hold-height {
    height: 32px;
  }
  .content {
    width: 1150px;
  }
}
.header-menu {
  width: 100%;
  width: 1150px;
  margin: auto;
  line-height: 32px;
  height: 32px;
  color: $color-headerMenuColor;
  display: flex;
  align-items: center;
  /deep/ .ivu-select-dropdown {
    padding: 0;
  }
  /deep/.ivu-dropdown-item-divided:before {
    display: none;
  }
  .headRight {
    .itemBox {
      .item {
        padding: 0 15px;
        cursor: pointer;
        font-size: 12px;
        color: #555555;
        &:hover {
          @include color_primary($color-primary);
        }
        .goodsNum {
          font-size: 12px;
          @include color_primary($color-primary);
        }
      }
    }
    /deep/ .ivu-dropdown-item:hover {
      background: #ffffff;
    }
  }

  .userBox {
    margin-left: 25px;
    /deep/ .ivu-select-dropdown {
      padding: 0;
      margin: 0;
      // iView 的面板是 width: inherit、菜单是 min-width: 100px，两者宽度不一致时
      // hover 高亮会和面板边缘对不齐（看起来「没铺满」）。这里让面板按内容自适应，
      // 并裁掉圆角：选项 hover 才是完整的整行高亮
      width: auto !important;
      // min-width: 120px;
      overflow: hidden;
      border-radius: 4px;
    }
    /deep/ .ivu-dropdown-menu {
      // 菜单铺满面板，选项 hover 才能盖到左右边缘
      width: 100%;
      min-width: 0;
      padding: 0;
    }
    /deep/ .ivu-dropdown-item {
      margin: 0;
      padding: 8px 16px;
    }
    /deep/ .ivu-dropdown {
      a {
        @include color_primary($color-primary);
      }
    }
  }
  .icon {
    // width: 120px;
    // margin-right: 20px;
    display: none;
  }
  &.fixed {
    position: fixed;
    top: 0;
    left: 0;
    background-color: #fff;
    z-index: 999;
    width: 100%;
    min-width: 1150px;
    margin: auto;
    line-height: 50px;
    height: 50px;
    box-shadow: $box-shadow-base;
    transition: all 0.2s;
    .icon {
      // width: 120px;
      height: 30px;
      // margin-right: 20px;
      display: block;
    }
    .logBtn {
      font-size: 12px;
      background: #ffffff;
      height: 32px;
      color: $color-headerMenuColor;
      &:hover {
        @include color_primary($color-primary);
      }
    }
    .headRight {
      .itemBox {
        .item {
          padding: 0 15px;
          cursor: pointer;
          font-size: 12px;
          color: #555555;
          &:hover {
            @include color_primary($color-primary);
          }
          .goodsNum {
            font-size: 12px;
            @include color_primary($color-primary);
          }
        }
      }
    }
    /deep/ .ivu-btn,
    .ivu-btn:active,
    .ivu-btn:focus {
      outline: none;
      outline-color: transparent;
      background: #fff;
    }
    /deep/ .ivu-dropdown {
      display: flex;
      align-items: center;
    }
  }
  /deep/ .ivu-btn,
  .ivu-btn:active,
  .ivu-btn:focus {
    outline: none;
    outline-color: transparent;
    background: #f1f1f1;
  }
  .service {
    /deep/ .dropdown-p {
      height: 32px;
      &:hover {
        @include color_primary($color-primary);
      }
    }
  }
  .mobile-qrcode {
    width: 160px;
    height: auto;
  }
  .dropdown-p {
    cursor: pointer;
    font-size: 12px;
    height: 30px;
    &:hover {
      color: $link-color;
    }
  }
  .logBtn {
    font-size: 12px;
    background: #f1f1f1;
    height: 32px;
    color: $color-headerMenuColor;
    &:hover {
      @include color_primary($color-primary);
    }
  }
}
</style>
